<mat-dialog-content>
    <div class="dialog-header">
        <h3 translate>{{ data.title || 'input-confirm' | translate }}</h3>
        <button class="close-button" mat-icon-button tabindex="-1" cdkFocusInitial (click)="closeDialog()"
            id="confirmModal-header-button-close">
            <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
        </button>
    </div>

    <div class="dialog-content">
        <p>{{ data.message | translate}}</p>
    </div>

    <div class="dialog-actions">
        <button mat-raised-button color="primary" (click)="onConfirm()" translate>
            {{ data.confirmText || 'option-yes' | translate}}
        </button>
        <button mat-button (click)="closeDialog(true)" translate>
            {{ data.cancelText || 'option-no' | translate}}
        </button>
    </div>
</mat-dialog-content>